module.exports = __webpack_public_path__ + "img/logo_secondary_full.805d54e5.png";